import { useAuthentication } from '@givebacks/api';
import { useBreakPoints } from 'core';

import { DesktopHamburgerMenu } from './Menus/DesktopMenu/DesktopHamburgerMenu';
import { MobileHamburgerMenu } from './Menus/MobileMenu/MobileHamburgerMenu';

const HamburgerMenu = () => {
  const { isAuthenticated } = useAuthentication();
  const { isSmallScreen } = useBreakPoints();

  return (
    <>
      {isSmallScreen ? <MobileHamburgerMenu /> : isAuthenticated && <DesktopHamburgerMenu />}
      {/* {isShowMenuAction && (
          <ActionIcon size="md" color="gray" onClick={() => setIsMenuDrawerOpen(true)}>
            <Burger
              opened={isMenuDrawerOpen}
              onClick={() => setIsMenuDrawerOpen(true)}
              styles={{
                burger: {
                  '::before': {
                    width: '1rem',
                  },
                  '::after': {
                    width: '1rem',
                  },
                  '&[data-opened]::before': {
                    width: '1.5rem',
                  },
                  '&[data-opened]::after': {
                    width: '1.5rem',
                  },
                },
              }}
            />
          </ActionIcon>
        )} */}
    </>
  );
};

export { HamburgerMenu };
